import { useState, useEffect } from 'react';
import { getUserList } from '../../store/app/apis';
import TablePagination from '@mui/material/TablePagination';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import CreateUser from '../../components/CreateUser/CreateUser';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteUser, fetchProjectList } from '../../store/app/apis';
import { connect } from 'react-redux';
import Toast from 'light-toast';
import { setUserList, updateUserList } from '../../store/app';
import { ROLE } from '../../constants';
import '../notifications/index.css';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircularProgress from '@mui/material/CircularProgress';

export function UserRoute({
  userList,
  userCount,
  projectList,
  projectCount,
  setUserList,
  fetchProjectList,
  deleteUser,
  getUserList,
  ...props
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [id, setId] = useState('');
  const [page, setPage] = useState(0);
  const [progress, setProgress] = useState(false);
  const open = Boolean(menuAnchorEl);
  const userRole = {
    [ROLE.NONE]: 'None',
    [ROLE.USER]: 'User',
    [ROLE.ADMIN]: 'Admin',
  };
  const styles = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
  };

  useEffect(() => {
    var payload2 = {};
    payload2['size'] = 100;
    fetchProjectList(payload2);
  }, []);
  useEffect(() => {
    if (projectList?.length === 0 || projectList?.count === 0) return;
    var payload = {};
    payload['page'] = page + 1;
    getUserList(payload).then((res) => {
      OnUserList(res);
    });
  }, [page, projectList]);
  function OnUserList(resp) {
    if (projectList?.length !== 0) {
      if (resp != null) {
        var u = [...resp.list];
        for (var key in projectList) {
          for (var i = 0; i < u.length; i++) {
            if (u[i].projects?.includes(projectList[key].id)) {
              u[i] = { ...u[i], projectNames: (u[i].projectNames || '') + projectList[key].title + ', ' };
            }
          }
        }

        setUserList({ list: u, count: resp?.count });
        setProgress(true);
      }
    }
  }

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setId('');
  };
  const handleMenu = (event, id) => {
    setMenuAnchorEl(event.currentTarget);
    setId(id);
  };

  const handleDialog = () => {
    setMenuAnchorEl(null);
    setOpenConfirmationDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleClose = (issuccess) => {
    setOpenConfirmationDialog(false);
    if (issuccess) {
      deleteUser(id);
    }
  };
  const copyToClipboard = (text) => {
    if (typeof text === 'object') text = JSON.stringify(text);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Toast.success('Copied!', 1000);
        setMenuAnchorEl(null);
      })
      .catch((error) => {
        console.error(error);
        Toast.fail('Text not copied!');
        setMenuAnchorEl(null);
      });
  };

  const handleEditClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setMenuAnchorEl(null);
  };

  return (
    <>
      <div className="buttonclass">
        <button onClick={handleClick} style={{ display: 'flex' }}>
          <AddBoxIcon size="small" />
          Add User
        </button>
      </div>
      <div className="fulltablediv">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>User Name</th>
              <th>Role</th>
              <th>Projects</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!progress && <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />}
            {progress &&
              userList?.map((user) => (
                <tr key={user?.id}>
                  <td>{user?.name}</td>
                  <td>{user?.username}</td>
                  <td>{userRole[user.role]}</td>
                  <td>{user?.projectNames}</td>
                  <td>
                    <MoreVertIcon sx={{ cursor: 'pointer' }} onClick={(event) => handleMenu(event, user?.id)} />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <Menu
        id="profile-menu"
        anchorEl={menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
        open={open}
        variant="selectedMenu"
      >
        <MenuItem value={10}>
          <button onClick={() => handleDialog()} className="iconsText">
            <DeleteIcon />
            Delete
          </button>
        </MenuItem>
        <MenuItem value={30}>
          <button
            onClick={() => copyToClipboard(userList?.filter((user) => user.id === id)[0]['id'])}
            className="iconsText"
          >
            <ContentCopyIcon />
            copy
          </button>
        </MenuItem>
        <MenuItem value={20}>
          <button onClick={handleEditClick} className="iconsText">
            <EditIcon />
            Update
          </button>
        </MenuItem>
      </Menu>
      <TablePagination
        rowsPerPageOptions={[10]}
        component="div"
        count={userCount}
        rowsPerPage={10}
        page={page}
        onPageChange={handleChangePage}
        sx={styles}
      />
      {anchorEl && <CreateUser anchorEl={anchorEl} id={id} token={props.token} onClose={handleClick} />}
      {openConfirmationDialog && <ConfirmationDialog closedialog={handleClose} />}
    </>
  );
}

const mapStateToProps = (state) => ({
  projectList: state.app.projectList,
  projectCount: state.app.projectCount,
  userList: state.app.userList,
  userCount: state.app.userCount,
});
const mapDispatchToProps = { setUserList, updateUserList, fetchProjectList, deleteUser, getUserList };

export default connect(mapStateToProps, mapDispatchToProps)(UserRoute);
